import graphql from './graphql';

const query = /* GraphQL */ `
  query User_listUsersByPrivateLesson($lessonId: ID!) {
    User_listUsersByPrivateLesson(lessonId: $lessonId) {
      User {
        id
        fullName
      }
    }
  }
`;

const UserListUsersByPrivateLesson = async ({ lessonId = null }) =>
  graphql(query, { lessonId }).then(
    // eslint-disable-next-line camelcase
    ({ User_listUsersByPrivateLesson }) => User_listUsersByPrivateLesson
  );

export default UserListUsersByPrivateLesson;
